import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import LoaderSpinner from "./Components/LoaderSpinner";
import Main from "./Layout/Main";
import PrivateRoute from "./Stack/PrivateRoute";
import PublicRoute from "./Stack/PublicRoute";
import { setTheme } from "./store/reducer/theme";
import Application from "./Views/PrivateStack/Application/Application";
import Applications from "./Views/PrivateStack/Application/Applications";
import NewApplication from "./Views/PrivateStack/Application/NewApplication";
import Home from "./Views/PrivateStack/Home";
import Message from "./Views/PrivateStack/Message/Message";
import Messages from "./Views/PrivateStack/Message/Messages";
import Profile from "./Views/PrivateStack/Profile";
import NewUser from "./Views/PrivateStack/User/NewUser";
import User from "./Views/PrivateStack/User/User";
import Users from "./Views/PrivateStack/User/Users";
import Login from "./Views/PublicStack/Login";

function App() {
  const loading = useSelector((state) => state.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    const theme =
      localStorage.getItem("theme") ||
      window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";

    theme === "light"
      ? document.body.classList.remove("dark-mode")
      : document.body.classList.add("dark-mode");
    dispatch(setTheme(theme));
    localStorage.setItem("theme", theme);
  }, []);

  return (
    <>
      {loading && <LoaderSpinner />}
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Login />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route element={<Main />}>
            <Route path="/" element={<Home />} />
            <Route path="messages" element={<Messages />} />
            <Route path="message/:id" element={<Message />} />
            <Route path="applications" element={<Applications />} />
            <Route path="application/:id" element={<Application />} />
            <Route path="nouvelapplication" element={<NewApplication />} />
            <Route path="utilisateurs" element={<Users />} />
            <Route path="utilisateur/:id" element={<User />} />
            <Route path="nouvelutilisateur" element={<NewUser />} />
            <Route path="profile" element={<Profile />} />
            <Route path="/*" element={<Home />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
